import script from "./AdmHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdmHomeView.vue?vue&type=script&setup=true&lang=js"

import "./AdmHomeView.vue?vue&type=style&index=0&id=bd57b800&lang=css"

const __exports__ = script;

export default __exports__